<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import requestFunctions from "@functions/requestFunctions";

export default {

    page: {
		title: 'Перемещения',
		meta: [{ name: 'description', content: appConfig.description }],
	},

    components: { Layout, PageHeader, requestFunctions },

	data() {
		return {
			title: 'Перемещения',
			items: [],
            tableData: [],
            currentPage: 1,
            perPage: 50,
            pageOptions: [10, 25, 50, 100, 500],
            filter: null,
            filterOn: null,
            sortBy: 'document_date',
            sortDesc: true,
            fields: [
                { key: 'select', label: '', row:{'rowSelected':false}},
                { key: 'id', label: 'ID', sortable: true },
                { key: 'document_date', label: 'Дата', sortable: true },
                { key: 'number', label: 'Номер документа', sortable: true },
                { key: 'company_from_name', label: 'Компания отправитель', sortable: true },
                { key: 'counterparty_from_name', label: 'Контрагент отправитель', sortable: true },
                { key: 'warehouse_from_name', label: 'Склад отправления', sortable: true },
                { key: 'company_to_name', label: 'Компания получатель', sortable: true },
                { key: 'counterparty_to_name', label: 'Контрагент получатель', sortable: true },
                { key: 'warehouse_to_name', label: 'Склад прибытия', sortable: true },
                { key: 'sum', label: 'Сумма', sortable: true },
                { key: 'comments', label: 'Комментарий', sortable: true },
                { key: 'status', label: 'Статус', row:{'rowSelected':false} },
                { key: 'updated_at', label: 'Изменено', sortable: true },
                { key: 'action', label: ''}
            ],
            tableLoading: true,
            watch: false,
            sum: 0
		}
	},

    watch: {
        sortBy: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onSorted();
                }
            }
        },
        sortDesc: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onSorted();
                }
            }
        },
        perPage: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onChangePerPage();
                }
            }
        },
        currentPage: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onChangeCurrentPage();
                }
            }
        },
    },
    computed: {
        total_rows() {
            return this.$store.getters['movings/GET_MOVINGS_TOTAL_ROWS'];
        },
        table_data() {
            this.tableLoading = false;
            return this.$store.getters['movings/GET_MOVINGS_TABLE_DATA'];
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            return session.user ? session.user : null;
        },
        session_item(){
            return this.$store.getters['sessions/GET_SESSIONS_ITEM'];
        }

    },

    async mounted() {
        await this.getData();
    },

    methods: {
        async onFiltered() {
            this.currentPage = 1;
            await this.getData();
        },
        async onSorted(){
            await this.getData();
        },
        async onChangePerPage(){
            this.currentPage = 1;
            await this.getData();
        },
        async onChangeCurrentPage(){
            await this.getData();
        },
        async getData(){

            this.tableLoading = true;

            let data_send = {
                'limit'    : this.perPage,
                'page'     : this.currentPage,
                'sortBy'   : this.sortBy,
                'sortDesc' : this.sortDesc === false ? 'ASC' : 'DESC',
                'filter'   : this.filter,
                'filterOn' : JSON.stringify(this.filterOn)
            }

            await this.$store.dispatch('movings/FETCH_MOVINGS_LIST', data_send);
            
            data_send = {
                'limit'    : 100000,
                'sum'      : 'sum',
                'page'     : this.currentPage,
                'sortBy'   : this.sortBy,
                'sortDesc' : this.sortDesc === false ? 'ASC' : 'DESC',
                'filter'   : this.filter,
                'filterOn' : JSON.stringify(this.filterOn)
            }
            let response = await requestFunctions.sendDataAsync('https://api.tradeanalytic.ru/v1/movings', data_send, 'GET');            
            this.sum = response['data'];
            this.watch = true;
        },
        async delItem(uuid){
            await this.$store.dispatch('movings/FETCH_MOVINGS_DELETE', {uuid: uuid});
            await this.getData();
            return false;
        },
        async print(uuid){
            window.open('https://api.tradeanalytic.ru/v1/docs/print/moving/' + uuid, '_blank');
        }
    },
}
</script>

<template>
	<Layout>
        <div class="row page-title align-items-center">
            <div class="col-sm-4 col-xl-6">
                <h4 class="mb-1 mt-0">{{ title }} <span style="font-size: 14px">на сумму: {{ sum }} руб.</span></h4>
            </div>
            <div class="col-sm-8 col-xl-6">
                <form class="form-inline float-sm-right mt-3 mt-sm-0">
                    <div class="btn-group">
                        <router-link to="/account/movings/create" class="btn btn-primary" right>
                            <i class="uil uil-plus mr-1"></i>Новое перемещение
                        </router-link>
                    </div>
                </form>
            </div>
        </div>

        <div class="row">
            <div class="col-12">

                <div class="row" style="margin-top: 20px; margin-bottom: 5px">
                    <div class="col-sm-6 col-md-6">
                        <div id="tickets-table_length" class="dataTables_length">
                            <label class="d-inline-flex align-items-center">
                                Показывать&nbsp;
                                <b-form-select
                                    v-model="perPage"
                                    size="md"
                                    :options="pageOptions"
                                ></b-form-select
                                >&nbsp;записей
                            </label>
                        </div>
                    </div>
                    <!-- Search -->
                    <div class="col-sm-6 col-md-6">
                        <div
                            id="tickets-table_filter"
                            class="dataTables_filter text-md-right"
                        >
                            <label class="d-inline-flex align-items-center">
                                Поиск:
                                <b-form-input
                                    v-model="filter"
                                    type="search"
                                    @change="onFiltered()"
                                    placeholder="Введите текст..."
                                    class="form-control form-control-md ml-2"
                                ></b-form-input>
                            </label>
                        </div>
                    </div>
                    <!-- End search -->
                </div>

                <div class="card">
                    <div class="card-body" style="padding-left: 0px; padding-right: 0px;">
                        <div class="table-responsive mb-0">
                            <b-table
                                :items="table_data"
                                :fields="fields"
                                responsive="sm"
                                current-page="1"
                                :class = "tableLoading ? 'loading' : ''"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                            >
                                <template #cell(status)="row">
                                    <span
                                        class="badge"
                                        v-bind:class="[
                                            row.item.status === 'Проверить' ? 'badge-soft-danger' : '',
                                            row.item.status === 'Черновик' ? 'badge-soft-warning' : '',
                                            row.item.status === 'Закрыт' ? 'badge-soft-success' : '',
                                        ]"
                                    >{{ row.item.status }}</span>
                                </template>
                                <template #cell(action)="row">
                                    <b-dropdown
                                        variant="link"
                                        class="float-right"
                                        right
                                        toggle-class="p-0 text-muted arrow-none"
                                    >
                                        <template v-slot:button-content>
                                            <i class="uil uil-ellipsis-v font-size-14"></i>
                                        </template>
                                        <b-dropdown-item :to="{ name: 'Movings.edit', params: { uuid: row.item.uuid, copy: true }}"
                                            ><i class="uil uil-edit-alt mr-2"></i>Редактировать</b-dropdown-item
                                        >
                                        <b-dropdown-item href="javascript: void(0);" @click.native="print(row.item.uuid)">
                                            <i class="uil uil-print mr-2"></i>Распечатать
                                        </b-dropdown-item>
                                        <b-dropdown-item href="javascript: void(0);" @click.native="delItem(row.item.uuid)" variant="danger">
                                            <i class="uil uil-trash mr-2"></i>Удалить
                                        </b-dropdown-item>
                                    </b-dropdown>
                                </template>
                            </b-table>
                        </div>
                    </div>
                </div>

                <div class="row" style="margin-bottom: 30px">
                    <div class="col">
                        <div
                            class="dataTables_paginate paging_simple_numbers float-right"
                        >
                            <ul class="pagination pagination-rounded mb-0">
                                <!-- pagination -->
                                <b-pagination
                                    v-model="currentPage"
                                    :total-rows="total_rows"
                                    :per-page="perPage"
                                ></b-pagination>
                            </ul>
                        </div>
                    </div>
                </div>

            </div>
        </div>
	</Layout>
</template>

<style>
.table-responsive-sm{
    transition: all .5s;
}
.table-responsive-sm.loading{
    opacity: 0.3;
}
</style>